import axios from "axios";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useCookies } from "react-cookie";
import CopyToClipboard from "react-copy-to-clipboard";
import DatePicker from "react-datepicker";
import { Controller, useForm } from "react-hook-form";
import QRCode from "react-qr-code";
import { Link } from "react-router-dom";
import { Button, Card, Col, Form, FormGroup, Modal, ModalBody, Tooltip } from "reactstrap";
import {
  servicePutCampaigns,
  serviceAnalyzeContent,
  serviceGetCampaignDepartments,
  serviceGetCampaignProducts,
  serviceGetCampaign,
} from "services/campaign";
import { getTagLeadSource } from "services/tags";
import { toStartOfDayIso, toEndOfDayIso } from "../../utils/campaignDate";
import { getApiErrorMessage, getPermission } from "../../utils/Utils";
import Swal from "sweetalert2";
import {
  Block,
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Icon,
  RSelect,
} from "../../components/Component";
import Content from "../../layout/content/Content";
import Head from "../../layout/head/Head";
import { getChannelIdByDepartementId, getChannels } from "../../services/channel";
import { getDepartmentsAll } from "../../services/departments";
import { serviceGetUsersByDeparmentId } from "../../services/users";
import { serviceGetProfile } from "services/settings";

const DetailCampaign = ({ ...props }) => {
  const dataCampaign = useMemo(() => {
    const dataProps = props.location?.state?.campaign || {};
    return { data: dataProps, isEditing: props.location?.state?.edit ?? false };
  }, [props.location?.state]);

  const [cookies] = useCookies(["user"]);
  const [linkOption, setLinkOption] = useState([]);
  const [, setDataProfile] = useState([]);
  const [departmentOption, setDepartmentOption] = useState([]);
  const [linkAutoSelect] = useState({
    value: dataCampaign.data?.link?.id,
    label: dataCampaign.data?.link?.name,
  });
  const [contactOption, setContactOption] = useState([]);
  const [addLinkModal, setAddLinkModal] = useState(false);
  const [tooltipOpen, setTooltipOpen] = useState(false);
  const [successModal, setSuccessModal] = useState(false);
  const { errors, register, handleSubmit, control, reset, setValue, clearErrors } = useForm();
  const [isEditing, setIsEditing] = useState(dataCampaign.isEditing);
  const [waTargetVal, setWaTargetVal] = useState(dataCampaign.data?.waTarget);
  const [channelId, setChannelId] = useState({ id: dataCampaign.data?.channelId, phone: dataCampaign.data?.noWa });
  const roleFunctions = getPermission()["campaigns"]?.access || [];
  const [currentLink, setCurrentLink] = useState(dataCampaign.data?.shortUrl?.replace("https://astronacci.org/", ""));
  const [leadSourceOption, setLeadSourceOption] = useState([]);
  const [, setIsProfileLoaded] = useState(false);
  const [selectedLeadSource, setSelectedLeadSource] = useState("");

  const initialCampaignLink = dataCampaign.data?.campaignLink || dataCampaign.data?.campaign_link || "";
  const detectPlatformFromUrl = (url) => {
    if (!url || typeof url !== "string") return "other";
    const trimmed = url.trim();
    if (/^(https?:\/\/)?(www\.|m\.)?(youtube\.com|youtu\.be)\/.+$/i.test(trimmed)) {
      return "youtube";
    }
    if (/^(https?:\/\/)?(www\.)?instagram\.com\/.+$/i.test(trimmed)) {
      return "instagram";
    }
    return "other";
  };

  const extractDepartmentIdentifiers = (campaign) => {
    if (!campaign) return [];
    const raw = campaign.departments || campaign.campaignDepartment;
    if (!raw) return [];
    let list = raw;
    if (typeof list === "string") {
      try {
        const parsed = JSON.parse(list);
        if (Array.isArray(parsed)) list = parsed;
        else list = list.split(",").map((s) => s.trim());
      } catch {
        list = list.split(",").map((s) => s.trim());
      }
    }
    if (Array.isArray(list)) {
      const results = [];
      list.forEach((item) => {
        if (typeof item === "object" && item !== null) {
          if (item.id !== undefined && item.id !== null) results.push(String(item.id).trim());
          if (item.name) results.push(String(item.name).trim());
          if (item.value !== undefined && item.value !== null) results.push(String(item.value).trim());
        } else if (item !== undefined && item !== null) {
          results.push(String(item).trim());
        }
      });
      return results.filter(Boolean);
    }
    return [];
  };

  const extractProductIdentifiers = (campaign) => {
    if (!campaign) return [];
    const results = [];
    const rawList = campaign.products || campaign.campaignProduct;
    if (rawList) {
      let list = rawList;
      if (typeof list === "string") {
        try {
          const parsed = JSON.parse(list);
          if (Array.isArray(parsed)) list = parsed;
        } catch {}
      }
      if (Array.isArray(list)) {
        list.forEach((item) => {
          if (typeof item === "object" && item !== null) {
            if (item.id !== undefined && item.id !== null) results.push(String(item.id).trim());
            if (item.name) results.push(String(item.name).trim());
            if (item.value !== undefined && item.value !== null) results.push(String(item.value).trim());
          } else if (item !== undefined && item !== null) {
            results.push(String(item).trim());
          }
        });
      }
    }
    const rawString = campaign.product;
    if (rawString && typeof rawString === "string") {
      rawString.split(",").forEach((s) => {
        const trimmed = s.trim();
        if (trimmed && !results.includes(trimmed)) {
          results.push(trimmed);
        }
      });
    }
    return results.filter(Boolean);
  };

  const [platform, setPlatform] = useState(() => detectPlatformFromUrl(initialCampaignLink));
  const [contentUrl, setContentUrl] = useState(initialCampaignLink);
  const [isAnalyzing, setIsAnalyzing] = useState(false);
  const [openingMessage, setOpeningMessage] = useState(dataCampaign.data?.message || "");

  const [campaignDeptOptions, setCampaignDeptOptions] = useState([]);
  const [selectedCampaignDept, setSelectedCampaignDept] = useState(() => extractDepartmentIdentifiers(dataCampaign.data));

  const [campaignProductOptions, setCampaignProductOptions] = useState([]);
  const [selectedCampaignProducts, setSelectedCampaignProducts] = useState(() => extractProductIdentifiers(dataCampaign.data));
  const lastAnalyzedUrlRef = React.useRef(initialCampaignLink);
  const isAnalyzingRef = React.useRef(false);

  const fetchCampaignDepartments = async () => {
    try {
      const response = await serviceGetCampaignDepartments(cookies.SIDikey);
      const dataList = response?.data?.data || response?.data || [];
      if (Array.isArray(dataList)) {
        const options = dataList.map((item) => {
          if (typeof item === "string") {
            return { label: item, value: item };
          }
          const nameVal = item.name || item.departmentName || item.title || item.id || "";
          const idVal = item.id || nameVal;
          return { label: nameVal, value: idVal, raw: item };
        });
        setCampaignDeptOptions(options);
        return options;
      }
    } catch (error) {
      console.error("Error fetching campaign departments:", error);
    }
    return [];
  };

  const fetchCampaignProducts = async (deptIds = []) => {
    const rawIds = Array.isArray(deptIds)
      ? deptIds.filter(Boolean)
      : deptIds
      ? [deptIds]
      : [];

    const ids = rawIds
      .map((item) => (typeof item === "object" && item !== null ? item.id || item.value : item))
      .filter(Boolean);

    if (ids.length === 0) {
      setCampaignProductOptions([]);
      return [];
    }
    try {
      const responses = await Promise.all(
        ids.map((id) => serviceGetCampaignProducts(cookies.SIDikey, id))
      );

      let combinedData = [];
      responses.forEach((response) => {
        const dataList = response?.data?.data || response?.data || [];
        if (Array.isArray(dataList)) {
          combinedData = [...combinedData, ...dataList];
        }
      });

      const uniqueMap = new Map();
      combinedData.forEach((item) => {
        if (typeof item === "string") {
          if (!uniqueMap.has(item)) {
            uniqueMap.set(item, { label: item, value: item });
          }
        } else if (item && typeof item === "object") {
          const nameVal = item.name || item.productName || item.title || item.id || "";
          const idVal = item.id || nameVal;
          const itemDeptId = item.departmentId || item.department?.id || "";
          if (!uniqueMap.has(idVal)) {
            uniqueMap.set(idVal, { label: nameVal, value: idVal, departmentId: itemDeptId, raw: item });
          }
        }
      });

      const options = Array.from(uniqueMap.values());
      setCampaignProductOptions(options);
      return options;
    } catch (error) {
      console.error("Error fetching campaign products:", error);
    }
    setCampaignProductOptions([]);
    return [];
  };

  const isValidUrlForPlatform = (url, plat) => {
    if (!url || typeof url !== "string") return false;
    const trimmed = url.trim();
    if (plat === "youtube") {
      return /^(https?:\/\/)?(www\.|m\.)?(youtube\.com|youtu\.be)\/.+$/i.test(trimmed);
    } else if (plat === "instagram") {
      return /^(https?:\/\/)?(www\.)?instagram\.com\/.+$/i.test(trimmed);
    }
    return true;
  };

  const handleAnalyzeContent = async (urlVal) => {
    const urlToAnalyze = urlVal !== undefined ? urlVal : contentUrl;
    if (!urlToAnalyze || (platform !== "youtube" && platform !== "instagram")) return;

    if (!isValidUrlForPlatform(urlToAnalyze, platform)) {
      setContentUrl("");
      lastAnalyzedUrlRef.current = "";
      Swal.fire({
        icon: "error",
        title: "URL Tidak Valid",
        text: `Masukkan link ${platform === "youtube" ? "YouTube (youtube.com / youtu.be)" : "Instagram (instagram.com)"} yang valid.`,
      });
      return;
    }

    setIsAnalyzing(true);
    isAnalyzingRef.current = true;
    try {
      const res = await serviceAnalyzeContent(cookies.SIDikey, {
        url: urlToAnalyze,
        platform: platform,
      });

      // Cek apakah response error
      const isSuccess = res && res.status >= 200 && res.status < 300 && res.status !== "No Server Response";
      if (!isSuccess) {
        console.warn("Analysis API returned an error response:", res);
        setContentUrl("");
        lastAnalyzedUrlRef.current = "";
        Swal.fire({
          icon: "error",
          title: "Gagal Menganalisis Konten",
          text: res?.data?.message || res?.message || "URL tidak valid atau konten tidak dapat dianalisis.",
        });
        return;
      }

      const data = res?.data?.data || res?.data;
      if (data && typeof data === "object") {
        const nameVal = data.suggestedCampaignName || data.campaignName || data.name || data.title;
        if (nameVal) {
          setValue("campaignName", nameVal);
        }

        const linkVal = data.suggestedLinkSlug || data.link || data.linkName || data.shortlink;
        if (linkVal) {
          const cleanLink = String(linkVal).replace(/[^a-zA-Z0-9\-_()]/g, '');
          setValue("link", cleanLink);
          setCurrentLink(cleanLink);
          if (typeof checkLink === "function") {
            checkLink(cleanLink);
          }
        }

        const msgVal = data.whatsappOpeningMessage || data.whatsappOpeningMsg || data.openingMessage || data.message || data.description || data.content;
        if (msgVal) {
          setValue("message", msgVal, { shouldValidate: true, shouldDirty: true });
          setOpeningMessage(msgVal);
          setFormData((prev) => ({ ...prev, message: msgVal }));
          clearErrors("message");
        }

        // Auto-fill Campaign Department
        let activeDeptIds = selectedCampaignDept;
        let loadedProducts = campaignProductOptions;
        const targetDept = data.targetDepartment;
        if (targetDept) {
          let targetDeptsList = [];
          if (Array.isArray(targetDept)) {
            targetDeptsList = targetDept;
          } else if (targetDept !== null) {
            targetDeptsList = [targetDept];
          }

          const currentDeptOpts = campaignDeptOptions.length > 0 ? campaignDeptOptions : await fetchCampaignDepartments();
          const matchedDeptValues = [];

          targetDeptsList.forEach((td) => {
            let deptIdVal = "";
            let deptNameVal = "";
            if (typeof td === "object" && td !== null) {
              deptIdVal = td.id || td.value || "";
              deptNameVal = td.name || td.label || "";
            } else if (typeof td === "string") {
              deptIdVal = td;
              deptNameVal = td;
            }

            const matched = currentDeptOpts.find(
              (opt) =>
                (deptIdVal && (String(opt.value) === String(deptIdVal) || String(opt.raw?.id) === String(deptIdVal))) ||
                (deptNameVal && opt.label.toLowerCase().trim() === deptNameVal.toLowerCase().trim())
            );

            if (matched) {
              if (!matchedDeptValues.includes(matched.value)) {
                matchedDeptValues.push(matched.value);
              }
            } else if (deptIdVal || deptNameVal) {
              const fallbackVal = deptIdVal || deptNameVal;
              if (!matchedDeptValues.includes(fallbackVal)) {
                matchedDeptValues.push(fallbackVal);
              }
            }
          });

          if (matchedDeptValues.length > 0) {
            activeDeptIds = matchedDeptValues;
            setSelectedCampaignDept(matchedDeptValues);
            setValue("campaignDepartment", matchedDeptValues, { shouldValidate: true, shouldDirty: true });
            loadedProducts = await fetchCampaignProducts(matchedDeptValues);
          }
        }

        // Auto-fill Campaign Products
        const prodVal = data.suggestedProducts || data.campaignProduct || data.product || data.productName;
        if (prodVal) {
          const currentProdOpts = loadedProducts && loadedProducts.length > 0 ? loadedProducts : (campaignProductOptions.length > 0 ? campaignProductOptions : await fetchCampaignProducts(activeDeptIds));
          
          let rawProdList = [];
          if (Array.isArray(prodVal)) {
            rawProdList = prodVal;
          } else if (typeof prodVal === "object" && prodVal !== null) {
            rawProdList = [prodVal];
          } else if (typeof prodVal === "string") {
            rawProdList = prodVal.split(",").map((s) => s.trim());
          }

          const matchedProdValues = [];

          rawProdList.forEach((p) => {
            let pId = "";
            let pName = "";
            if (typeof p === "object" && p !== null) {
              pId = p.id || p.value || "";
              pName = p.name || p.title || p.label || "";
            } else {
              pId = String(p || "");
              pName = String(p || "");
            }

            const matched = currentProdOpts.find(
              (opt) =>
                (pId && (String(opt.value) === String(pId) || String(opt.raw?.id) === String(pId))) ||
                (pName && opt.label.toLowerCase().trim() === pName.toLowerCase().trim())
            );

            if (matched) {
              if (!matchedProdValues.includes(matched.value)) {
                matchedProdValues.push(matched.value);
              }
            } else if (pId || pName) {
              const fallbackVal = pId || pName;
              if (!matchedProdValues.includes(fallbackVal)) {
                matchedProdValues.push(fallbackVal);
              }
            }
          });

          setSelectedCampaignProducts(matchedProdValues);
          setValue("campaignProduct", matchedProdValues, { shouldValidate: true, shouldDirty: true });
          clearErrors("campaignProduct");
        }

        Swal.fire({
          icon: "success",
          title: "Analisis Konten Berhasil",
          text: "Form berhasil diisi secara otomatis dari hasil analisis.",
          timer: 2000,
          showConfirmButton: false,
        });
      }
    } catch (err) {
      console.error("Error analyzing content:", err);
      setContentUrl("");
      lastAnalyzedUrlRef.current = "";
      Swal.fire({
        icon: "error",
        title: "Gagal Menganalisis Konten",
        text: err?.response?.data?.message || err?.message || "Terjadi kesalahan saat menganalisis konten.",
      });
    } finally {
      setIsAnalyzing(false);
      isAnalyzingRef.current = false;
    }
  };

  const {
    errors: errorLink,
    register: registerLink,
    handleSubmit: handleSubmitLink,
    setError,
    setValue: setValueLink,
  } = useForm();
  let dataSelect = {
    waTarget: [
      { value: "Rotator", label: "Rotator" },
      //{ value: "Single", label: "Single" },
    ],
  };

  const refreshContactOption = async () => {
    //const responseGetChannels = await getChannels(cookies.SIDikey);
    //setContactOption(responseGetChannels?.data?.data.map((item) => ({ value: item.id, label: item.phoneNumber })));
    const responseGetUsers = await serviceGetUsersByDeparmentId(cookies.SIDikey, dataCampaign.data.departmentId);
    const waTarget = responseGetUsers.map((user) => {
      return {
        value: user.id,
        label: user.firstName + " " + user.lastName,
      };
    });
    setContactOption(waTarget);
  };

  const refreshLinkOption = () => {
    axios.interceptors.request.use((config) => {
      config.headers["Authorization"] = `Bearer ${cookies.SIDikey}`;
      config.headers["Content-Type"] = "application/json";
      config.headers["AccessControl-Allow-Origin"] = "http://localhost:3000";
      return config;
    });
    axios
      .get(process.env.REACT_APP_BASE_URL + "api/links")
      .then((response) => {
        const resultData = response.data;
        const finalData = [];
        resultData.data.forEach((departement) => {
          const tempData = {
            value: departement.id,
            label: departement.name,
            description: departement.description,
          };
          finalData.push(tempData);
        });
        setLinkOption(finalData);
      })
      .catch((error) => {
        //console.log(error);
      });
  };

  const addLink = (submitData) => {
    const { linkName, description } = submitData;
    axios.interceptors.request.use((config) => {
      config.headers["Authorization"] = `Bearer ${cookies.SIDikey}`;
      config.headers["Content-Type"] = "application/json";
      config.headers["AccessControl-Allow-Origin"] = "http://localhost:3000";
      return config;
    });
    axios
      .post(process.env.REACT_APP_BASE_URL + "api/links?page=1&take=50", {
        name: linkName,
        description: description,
      })
      .then((response) => {
        Swal.fire({
          icon: "success",
          title: "Succesfull Transasction",
          focusConfirm: false,
        }).then(() => {
          refreshLinkOption();
          setAddLinkModal(false);
        });
      })
      .catch((error) => {
        //console.log(error);
        const errorMessage = getApiErrorMessage(error?.response || error, "Gagal membuat link.");
        Swal.fire({
          icon: "error",
          title: "Unsuccessful Transaction",
          text: errorMessage,
          focusConfirm: false,
        });
      });
  };

  const getProfile = async () => {
    try {
      const responseProfile = await serviceGetProfile(cookies.SIDikey);
      const resultData = responseProfile.data.departments;
      const finalData = resultData.map(department => ({
        id: department.id,
        color: department.color,
        name: department.name,
      }));
      setDataProfile(finalData);
      setIsProfileLoaded(true);
    } catch (error) {
      console.error("Error fetching profile:", error);
    }
  };

  const refreshDepartmentOption = async () => {
    try {
      const responseGetDepartments = await getDepartmentsAll(
        cookies.SIDikey,
        ["Access_All_Dept"],
        "DESC",
        "department.createdAt"
      );
      let depts = responseGetDepartments.data;
      if (roleFunctions.includes("Access_Own_Dept")) {
        depts = depts.filter(df => cookies.departmentIds.includes(df.id));
      }
      const responseGetChannels = await getChannels(cookies.SIDikey);
      const deptIdsWithPhone = (responseGetChannels?.data?.data || [])
        .filter((channel) => channel.phoneNumber)
        .map((channel) => channel.departmentId);
      depts = depts.filter((dept) => deptIdsWithPhone.includes(dept.id));

      //console.log("Filtered Departments:", depts);
      setDepartmentOption(depts);
    } catch (error) {
      console.error("Error refreshing department options:", error);
      setDepartmentOption([]);
    }
  };

  const fetchLeadSource = async () => {
    const responseGetLeadSources = await getTagLeadSource(cookies.SIDikey, ["Access_All_Dept"], 0);

    setLeadSourceOption([
      ...responseGetLeadSources.data.map((item) => ({
        value: item.id,
        label: item.name,
      })),
    ]);
  };

  const [formData, setFormData] = useState({
    link: linkAutoSelect,
    campaignName: dataCampaign.data?.name,
    campaignProduct: dataCampaign.data?.product,
    campaignLink: initialCampaignLink,
    departementTarget: {
      value: dataCampaign.data?.department?.id,
      label: dataCampaign.data?.department?.name,
      color: dataCampaign.data?.department?.color,
    },
    waTarget: dataCampaign.data?.waTarget,
    waNumber: dataCampaign.data?.noWa,
    message: dataCampaign.data?.message,
    active: dataCampaign.data?.status === "ACTIVE" ? true : false,
    shortlink: dataCampaign.data?.shortUrl,
    id: dataCampaign.data?.id,
    channelId: dataCampaign.data?.channelId,
    department: dataCampaign.data?.department,
    userId: dataCampaign.data?.userId,
    username: dataCampaign.data?.username,
    leadSourceId: dataCampaign.data?.leadSourceId,
    leadSourceTarget: {
      value: dataCampaign.data?.leadSourceId || "",
      label: dataCampaign.data?.leadSourceData != null ? dataCampaign.data?.leadSourceData.name : "",
    },
  });

  const [startDate, setStartDate] = useState(
    dataCampaign.data.startDate ? new Date(dataCampaign.data.startDate) : null
  );
  const [endDate, setEndDate] = useState(
    dataCampaign.data.endDate ? new Date(dataCampaign.data.endDate) : null
  );

  const onFormSubmit = async (e) => {
    if (isAnalyzingRef.current) return;
    if (channelId.id === "" && channelId.phone === "") {
      Swal.fire({
        icon: "error",
        title: "Unsuccesful Create Campaign Link",
        text: "Buat channel terlebih dahulu dengan department yang dipilih sekarang",
        focusConfirm: false,
      });
      return;
    }

    const deptValues = Array.isArray(e.campaignDepartment)
      ? e.campaignDepartment
      : Array.isArray(selectedCampaignDept)
      ? selectedCampaignDept
      : selectedCampaignDept
      ? [selectedCampaignDept]
      : [];

    const selectedDepartmentsPayload = deptValues.map((val) => {
      const opt = campaignDeptOptions.find((o) => o.value === val || o.label === val);
      if (opt && opt.raw && typeof opt.raw === "object") {
        return opt.raw;
      }
      return {
        id: opt ? opt.value : val,
        name: opt ? opt.label : val,
      };
    });

    const prodValues = Array.isArray(e.campaignProduct)
      ? e.campaignProduct
      : Array.isArray(selectedCampaignProducts)
      ? selectedCampaignProducts
      : selectedCampaignProducts
      ? [selectedCampaignProducts]
      : [];

    const selectedProductsPayload = prodValues.map((val) => {
      const opt = campaignProductOptions.find((o) => o.value === val || o.label === val);
      if (opt && opt.raw && typeof opt.raw === "object") {
        return opt.raw;
      }
      return {
        id: opt ? opt.value : val,
        name: opt ? opt.label : val,
      };
    });

    let submittedData = {
      linkName: e.link,
      name: e.campaignName,
      departments: selectedDepartmentsPayload,
      products: selectedProductsPayload,
      product: Array.isArray(e.campaignProduct)
        ? e.campaignProduct
            .map((val) => {
              const opt = campaignProductOptions.find((o) => o.value === val);
              return opt ? opt.label : val;
            })
            .join(",")
        : e.campaignProduct
        ? String(e.campaignProduct).replace(/\s/g, "")
        : "",
      campaignLink: contentUrl || e.campaignLink || "",
      departmentId: e.departementTarget,
      waTarget: e.waTarget,
      channelId: channelId.id,
      message: e.message,
      status: formData.active ? "ACTIVE" : "INACTIVE",
      noWa: "+" + channelId.phone,
      userId: e.waNumber?.value,
      username: e.waNumber?.label,
      leadSourceId: e.leadSourceId,
      startDate: startDate ? toStartOfDayIso(startDate) : null,
      endDate: endDate ? toEndOfDayIso(endDate) : null,
    };

    if (startDate && endDate && endDate < startDate) {
      Swal.fire({
        icon: "error",
        title: "Tanggal tidak valid",
        text: "Tanggal selesai harus setelah tanggal mulai",
        focusConfirm: false,
      });
      return;
    }

    setFormData((prev) => ({
      ...prev,
      link: e.link,
      campaignProduct: e.campaignProduct ? String(e.campaignProduct).replace(/\s/g, "") : "",
      campaignLink: contentUrl || e.campaignLink || "",
      departementTarget: e.departementTarget,
      shortlink: "https://astronacci.org/" + e.link,
    }));
    const responsePutCampaign = await servicePutCampaigns(dataCampaign.data.id, cookies.SIDikey, submittedData);
    const isSuccess =
      (typeof responsePutCampaign?.status === "number" &&
        responsePutCampaign.status >= 200 &&
        responsePutCampaign.status < 300 &&
        responsePutCampaign.status !== "No Server Response") ||
      responsePutCampaign?.statusText === "OK" ||
      responsePutCampaign?.statusText === "Accepted" ||
      responsePutCampaign?.statusText === "Created";

    if (!isSuccess) {
      const errorMessage = getApiErrorMessage(responsePutCampaign, "Gagal memperbarui campaign.");
      Swal.fire({
        icon: "error",
        title: "Unsuccessful Update Campaign Link",
        text: errorMessage,
        focusConfirm: false,
      });
      return false;
    }
    setSuccessModal(true);
    reset({});
  };

  const onActiveCheck = (e) => {
      setFormData((prev) => ({
        ...prev,
        active: !prev.active,
      }));
    };

  useEffect(() => {
    const initializeData = async () => {
      try {
        await getProfile();
        await refreshDepartmentOption();
        refreshLinkOption();
        refreshContactOption();
        fetchLeadSource();

        if (formData.departementTarget?.value) {
          setValue("departementTarget", formData.departementTarget.value);
        }
        setValue("waTarget", formData.waTarget);
        setValue("leadSourceId", formData.leadSourceId);
        if (contentUrl) {
          setValue("campaignLink", contentUrl);
        }

        let campaignItem = dataCampaign.data;
        if (dataCampaign.data?.id) {
          try {
            const resSingle = await serviceGetCampaign(cookies.SIDikey, dataCampaign.data.id);
            if (resSingle?.data) {
              campaignItem = { ...campaignItem, ...resSingle.data };
            }
          } catch (err) {
            console.warn("Could not fetch single campaign detail, using props data", err);
          }
        }

        const freshLink = campaignItem?.campaignLink || campaignItem?.campaign_link || "";
        if (freshLink) {
          const detected = detectPlatformFromUrl(freshLink);
          setPlatform(detected);
          setContentUrl(freshLink);
          lastAnalyzedUrlRef.current = freshLink;
          setValue("campaignLink", freshLink);
        }

        const deptOpts = await fetchCampaignDepartments();
        const deptIdents = extractDepartmentIdentifiers(campaignItem);
        let activeDeptValues = [];

        if (deptOpts && deptOpts.length > 0 && deptIdents.length > 0) {
          deptIdents.forEach((ident) => {
            const identLower = String(ident).toLowerCase().trim();
            const matched = deptOpts.find((opt) => {
              const optVal = String(opt.value).toLowerCase().trim();
              const optLabel = String(opt.label).toLowerCase().trim();
              const optRawId = opt.raw?.id ? String(opt.raw.id).toLowerCase().trim() : "";
              return identLower === optVal || identLower === optLabel || identLower === optRawId;
            });
            if (matched && !activeDeptValues.includes(matched.value)) {
              activeDeptValues.push(matched.value);
            } else if (!matched && !activeDeptValues.includes(ident)) {
              activeDeptValues.push(ident);
            }
          });
        }

        if (activeDeptValues.length > 0) {
          setSelectedCampaignDept(activeDeptValues);
          setValue("campaignDepartment", activeDeptValues);

          const prodOpts = await fetchCampaignProducts(activeDeptValues);
          const prodIdents = extractProductIdentifiers(campaignItem);

          if (prodOpts && prodOpts.length > 0 && prodIdents.length > 0) {
            const activeProdValues = [];
            prodIdents.forEach((ident) => {
              const identLower = String(ident).toLowerCase().trim();
              const matched = prodOpts.find((opt) => {
                const optVal = String(opt.value).toLowerCase().trim();
                const optLabel = String(opt.label).toLowerCase().trim();
                const optRawId = opt.raw?.id ? String(opt.raw.id).toLowerCase().trim() : "";
                return identLower === optVal || identLower === optLabel || identLower === optRawId;
              });
              if (matched && !activeProdValues.includes(matched.value)) {
                activeProdValues.push(matched.value);
              } else if (!matched && !activeProdValues.includes(ident)) {
                activeProdValues.push(ident);
              }
            });

            if (activeProdValues.length > 0) {
              setSelectedCampaignProducts(activeProdValues);
              setValue("campaignProduct", activeProdValues);
              clearErrors("campaignProduct");
            }
          }
        }
      } catch (error) {
        console.error("Error initializing data:", error);
      }
    };

    initializeData();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const departementSelected = useCallback(
    async (departmentId) => {
      const responseGetUsers = await serviceGetUsersByDeparmentId(cookies.SIDikey, departmentId.value);
      const channelId = await getChannelIdByDepartementId(cookies.SIDikey, departmentId.value);
      const waTarget = responseGetUsers.map((user) => {
        return {
          value: user.id,
          label: user.firstName + " " + user.lastName,
        };
      });
      setContactOption(waTarget);
      const channelWithPhone = channelId?.data?.data?.find((channel) => channel.phoneNumber);
      if (channelWithPhone) {
        setChannelId({
          phone: channelWithPhone.phoneNumber,
          id: channelWithPhone.id,
        });
      } else {
        setChannelId({
          phone: "",
          id: "",
        });
      }
      clearErrors("departementTarget");
    },
    [cookies.SIDikey] // eslint-disable-line react-hooks/exhaustive-deps
  );

  const checkLink = useCallback(
    (name) => {
      const uniqLink = linkOption.find((link) => link.label === name);
      //console.log("uniq", uniqLink);
      //console.log("link option", linkOption);
      if (uniqLink) {
        //console.log("isUnieq", uniqLink);
        setError("link", { type: "error", message: "Name link harus unik!" });
      } else {
        clearErrors("link");
        setValue("link", name);
        setCurrentLink(name);
      }
    },
    [clearErrors, linkOption, setError, setValue]
  );

  return (
    <React.Fragment>
      <Head title="Add Campaign" />
      <Content>
        <BlockHead size="sm">
          <BlockHeadContent>
            <BlockTitle tag="h3" page>
              Campaign
            </BlockTitle>
          </BlockHeadContent>
        </BlockHead>

        <Block>
          <Card className="p-4">
            <BlockHead>
              <BlockBetween>
                <BlockHeadContent>
                  <strong style={{ fontSize: 18 }}>Edit Campaign</strong>
                </BlockHeadContent>
              </BlockBetween>
            </BlockHead>
            <Block>
              <Form key="addData" className="row gy-4" onSubmit={handleSubmit(onFormSubmit)}>
                <Col md="6" lg="6">
                  <FormGroup className="form-group">
                    <label className="form-label">Platform / Source</label>
                    <div className="form-control-wrap">
                      <ul className="custom-control-group g-3 align-center">
                        <li>
                          <div className="custom-control custom-radio">
                            <input
                              disabled={!isEditing || isAnalyzing}
                              type="radio"
                              className="custom-control-input"
                              name="platform"
                              id="platformYoutubeEdit"
                              value="youtube"
                              checked={platform === "youtube"}
                              onChange={(e) => {
                                setPlatform(e.target.value);
                              }}
                            />
                            <label className="custom-control-label" htmlFor="platformYoutubeEdit">
                              YouTube
                            </label>
                          </div>
                        </li>
                        <li>
                          <div className="custom-control custom-radio">
                            <input
                              disabled={!isEditing || isAnalyzing}
                              type="radio"
                              className="custom-control-input"
                              name="platform"
                              id="platformInstagramEdit"
                              value="instagram"
                              checked={platform === "instagram"}
                              onChange={(e) => {
                                setPlatform(e.target.value);
                              }}
                            />
                            <label className="custom-control-label" htmlFor="platformInstagramEdit">
                              Instagram
                            </label>
                          </div>
                        </li>
                        <li>
                          <div className="custom-control custom-radio">
                            <input
                              disabled={!isEditing || isAnalyzing}
                              type="radio"
                              className="custom-control-input"
                              name="platform"
                              id="platformOtherEdit"
                              value="other"
                              checked={platform === "other"}
                              onChange={(e) => {
                                setPlatform(e.target.value);
                              }}
                            />
                            <label className="custom-control-label" htmlFor="platformOtherEdit">
                              Other
                            </label>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </FormGroup>

                  {(platform === "youtube" || platform === "instagram") && (
                    <FormGroup className="form-group">
                      <label className="form-label">
                        URL Content ({platform === "youtube" ? "YouTube" : "Instagram"})
                      </label>
                      <div className="form-control-wrap">
                        <input
                          disabled={!isEditing || isAnalyzing}
                          type="text"
                          className="form-control"
                          name="campaignLink"
                          placeholder={`Masukkan link ${platform === "youtube" ? "YouTube" : "Instagram"}...`}
                          value={contentUrl}
                          onChange={(e) => {
                            setContentUrl(e.target.value);
                            setValue("campaignLink", e.target.value);
                          }}
                          onKeyDown={(e) => {
                            // Enter = trigger analyze (via blur), bukan submit form
                            if (e.key === "Enter") {
                              e.preventDefault();
                              e.target.blur();
                            }
                          }}
                          onBlur={(e) => {
                            const val = e.target.value;
                            if (val && val !== lastAnalyzedUrlRef.current) {
                              lastAnalyzedUrlRef.current = val;
                              handleAnalyzeContent(val);
                            }
                          }}
                          ref={register()}
                        />
                        {isAnalyzing && (
                          <span className="form-note text-primary mt-1">
                            <span className="spinner-border spinner-border-sm mr-1" role="status" aria-hidden="true"></span>
                            Menganalisis konten...
                          </span>
                        )}
                      </div>
                    </FormGroup>
                  )}
                  <FormGroup>
                    <label className="form-label">Link</label>
                    <input
                      readOnly={true}
                      disabled={isAnalyzing}
                      className="form-control"
                      type="text"
                      name="link"
                      placeholder="Nama Link..."
                      ref={register({
                        required: "This field is required",
                      })}
                      onInput={(e) => {
                        const urlEncode = encodeURIComponent(e.target.value);
                        checkLink(urlEncode);
                      }}
                      defaultValue={linkAutoSelect.label}
                      onPaste={(e) => e.preventDefault()}
                      onKeyDown={(e) => {
                        if (e.key === " ") {
                          e.preventDefault();
                        }
                      }}
                    ></input>
                    {errors.link && (
                      <span className="invalid text-danger font-italic" style={{ fontSize: "11px" }}>
                        {errors.link.message}
                      </span>
                    )}
                  </FormGroup>

                  <FormGroup className="form-group">
                    <label className="form-label">Campaign Name</label>
                    <input
                      disabled={!isEditing || isAnalyzing}
                      className="form-control"
                      type="text"
                      name="campaignName"
                      defaultValue={formData.campaignName}
                      ref={register({
                        required: "This field is required",
                      })}
                    ></input>
                    {errors.campaignName && <span className="invalid">{errors.campaignName?.message}</span>}
                  </FormGroup>

                  <FormGroup className="form-group">
                    <label className="form-label">Campaign Department</label>
                    <RSelect
                      isMulti
                      isDisabled={!isEditing || isAnalyzing}
                      name="campaignDepartment"
                      options={campaignDeptOptions}
                      placeholder="Pilih Campaign Department..."
                      value={campaignDeptOptions.filter((opt) =>
                        selectedCampaignDept.some(
                          (val) =>
                            String(val).toLowerCase().trim() === String(opt.value).toLowerCase().trim() ||
                            String(val).toLowerCase().trim() === String(opt.label).toLowerCase().trim() ||
                            (opt.raw?.id && String(val).toLowerCase().trim() === String(opt.raw.id).toLowerCase().trim())
                        )
                      )}
                      onChange={(selected) => {
                        const values = selected ? selected.map((item) => item.value) : [];
                        setSelectedCampaignDept(values);
                        setValue("campaignDepartment", values, { shouldValidate: true });
                        setSelectedCampaignProducts([]);
                        setValue("campaignProduct", []);
                        if (values.length > 0) {
                          fetchCampaignProducts(values);
                        } else {
                          setCampaignProductOptions([]);
                        }
                      }}
                      {...register("campaignDepartment")}
                    />
                  </FormGroup>

                  <FormGroup className="form-group">
                    <label className="form-label">Campaign Product</label>
                    <RSelect
                      isMulti
                      isDisabled={!isEditing || isAnalyzing}
                      name="campaignProduct"
                      options={campaignProductOptions}
                      placeholder="Pilih Campaign Product..."
                      value={campaignProductOptions.filter((opt) =>
                        selectedCampaignProducts.some(
                          (val) =>
                            String(val).toLowerCase().trim() === String(opt.value).toLowerCase().trim() ||
                            String(val).toLowerCase().trim() === String(opt.label).toLowerCase().trim() ||
                            (opt.raw?.id && String(val).toLowerCase().trim() === String(opt.raw.id).toLowerCase().trim())
                        )
                      )}
                      onChange={(selected) => {
                        const values = selected ? selected.map((item) => item.value) : [];
                        setSelectedCampaignProducts(values);
                        setValue("campaignProduct", values, { shouldValidate: true });
                        clearErrors("campaignProduct");
                      }}
                      {...register("campaignProduct", { required: selectedCampaignProducts.length === 0 })}
                    />
                    {errors.campaignProduct && selectedCampaignProducts.length === 0 && (
                      <span className="text-danger font-italic" style={{ fontSize: "11px" }}>
                        This field is required
                      </span>
                    )}
                  </FormGroup>

                  {platform === "other" && (
                    <FormGroup>
                      <label className="form-label">Link Referensi</label>
                      <input
                        disabled={!isEditing || isAnalyzing}
                        className="form-control"
                        type="text"
                        name="campaignLink"
                        placeholder="Link referensi campaign (opsional)..."
                        value={contentUrl}
                        onChange={(e) => {
                          setContentUrl(e.target.value);
                          setValue("campaignLink", e.target.value);
                        }}
                        ref={register()}
                      />
                    </FormGroup>
                  )}

                  <FormGroup>
                    <label className="form-label">Department Target</label>

                    <RSelect
                      isDisabled={!isEditing || isAnalyzing}
                      name="departementTarget"
                      options={departmentOption?.map((item) => ({ label: item?.name, value: item.id }))}
                      placeholder="Pilih Department"
                      onChange={(e) => {
                        setValue("departementTarget", e.value);
                        departementSelected(e);
                      }}
                      defaultValue={formData.departementTarget}
                      {...register("departementTarget", { required: true })}
                    ></RSelect>
                    {errors.departementTarget && (
                      <span className="text-danger font-italic" style={{ fontSize: "11px" }}>
                        This field is required
                      </span>
                    )}
                  </FormGroup>

                  <FormGroup>
                    <label className="form-label">WA Target</label>
                    <RSelect
                      isDisabled={!isEditing || isAnalyzing}
                      name="waTarget"
                      options={dataSelect.waTarget}
                      placeholder="Pilih target"
                      onChange={(e) => {
                        setValue("waTarget", e.value);
                        setWaTargetVal(e.value);
                      }}
                      {...register("waTarget", { required: true })}
                      defaultValue={{ value: waTargetVal, label: waTargetVal }}
                    ></RSelect>
                    {errors.waTarget && (
                      <span className="text-danger font-italic" style={{ fontSize: "11px" }}>
                        This field is required
                      </span>
                    )}
                  </FormGroup>

                  {waTargetVal === "Single" && (
                    <FormGroup>
                      <label className="form-label">User</label>
                      <Controller
                        as={RSelect}
                        control={control}
                        rules={{ required: true }}
                        name="waNumber"
                        options={contactOption}
                        isDisabled={!isEditing || isAnalyzing}
                        // onChange={(e) => waNumberSelected(e)}
                        placeholder="Pilih Nomor WA"
                        defaultValue={{
                          value: formData.userId,
                          label: formData.username,
                        }}
                      />
                      {errors.waNumber && (
                        <span className="text-danger font-italic" style={{ fontSize: "11px" }}>
                          This field is required
                        </span>
                      )}
                    </FormGroup>
                  )}

                  <FormGroup>
                    <label className="form-label">Campaign Lead Source</label>
                    <RSelect
                      isDisabled={!isEditing || isAnalyzing}
                      name="leadSource"
                      defaultValue={formData.leadSourceTarget}
                      options={leadSourceOption?.map((item) => ({ label: item?.label, value: item.value }))}
                      placeholder="Pilih Lead Source"
                      onChange={(e) => {
                        setValue("leadSourceId", e?.value || "", { shouldValidate: true, shouldDirty: true });
                        setSelectedLeadSource(e?.value || "");
                        clearErrors("leadSourceId");
                      }}
                      {...register("leadSourceId", { required: true })}
                    ></RSelect>
                    {errors.leadSourceId && !selectedLeadSource && !formData.leadSourceId && (
                      <span className="text-danger font-italic" style={{ fontSize: "11px" }}>
                        This field is required
                      </span>
                    )}
                  </FormGroup>

                  <FormGroup>
                    <div className="custom-control custom-checkbox">
                      <input
                        disabled={!isEditing || isAnalyzing}
                        type="checkbox"
                        className="custom-control-input form-control"
                        id="newActive"
                        name="active"
                        defaultChecked={formData.active}
                        defaultValue={formData.active}
                        onChange={onActiveCheck}
                      />
                      <label className="custom-control-label" htmlFor="newActive">
                        Aktif
                      </label>
                    </div>
                  </FormGroup>

                  <FormGroup>
                    <label className="form-label">Tanggal Mulai (opsional)</label>
                    <DatePicker
                      disabled={!isEditing || isAnalyzing}
                      selected={startDate}
                      onChange={(date) => setStartDate(date)}
                      selectsStart
                      startDate={startDate}
                      endDate={endDate}
                      dateFormat="yyyy-MM-dd"
                      className="form-control date-picker"
                      placeholderText="Pilih tanggal mulai"
                      isClearable={isEditing && !isAnalyzing}
                    />
                  </FormGroup>

                  <FormGroup>
                    <label className="form-label">Tanggal Selesai (opsional)</label>
                    <DatePicker
                      disabled={!isEditing || isAnalyzing}
                      selected={endDate}
                      onChange={(date) => setEndDate(date)}
                      selectsEnd
                      startDate={startDate}
                      endDate={endDate}
                      minDate={startDate}
                      dateFormat="yyyy-MM-dd"
                      className="form-control date-picker"
                      placeholderText="Pilih tanggal selesai"
                      isClearable={isEditing && !isAnalyzing}
                    />
                  </FormGroup>
                </Col>
                <Col md="6" lg="6">
                  <div className="mt-5" style={{ fontSize: 14 }}>
                    <strong>
                      <span>https://astronacci.org/</span>
                      <span style={{ color: "#4461F2" }}>{currentLink}</span>
                    </strong>
                  </div>
                  <FormGroup>
                    <label className="form-label">Pesan Pembuka</label>
                    <textarea
                      disabled={!isEditing || isAnalyzing}
                      className="form-control"
                      name="message"
                      value={openingMessage}
                      ref={register({
                        required: "This field is required",
                      })}
                      onChange={(e) => {
                        setOpeningMessage(e.target.value);
                        setValue("message", e.target.value, { shouldValidate: true, shouldDirty: true });
                        setFormData((prev) => ({ ...prev, message: e.target.value }));
                        clearErrors("message");
                      }}
                    />
                    {errors.message && <span className="invalid">{errors.message.message}</span>}
                  </FormGroup>
                  <Block className="py-3">
                    <Card className="card-bordered card-bluesky p-2">
                      <strong>Pesan pembuka akan muncul saat customer akan memulai percakapan</strong>
                    </Card>
                  </Block>
                </Col>
                {isEditing ? (
                  <Col size="12">
                    <Link
                      to={isAnalyzing ? "#" : `${process.env.PUBLIC_URL + "/campaign"}`}
                      style={isAnalyzing ? { pointerEvents: "none" } : undefined}
                    >
                      <Button outline type="button" color="primary" className="mr-3" disabled={isAnalyzing}>
                        Batal
                      </Button>
                    </Link>
                    <Button color="primary" type="submit" disabled={isAnalyzing}>
                      {isAnalyzing ? (
                        <>
                          <span className="spinner-border spinner-border-sm mr-1" role="status" aria-hidden="true"></span>
                          Menganalisis...
                        </>
                      ) : (
                        "Simpan"
                      )}
                    </Button>
                  </Col>
                ) : (
                  <Col size="12">
                    <Link to={`${process.env.PUBLIC_URL + "/campaign"}`}>
                      <Button outline type="button" color="primary" className="mr-3">
                        Kembali
                      </Button>
                    </Link>

                    <Button type="button" color="primary" className="mr-3" onClick={() => setIsEditing(true)}>
                      Ubah
                    </Button>
                  </Col>
                )}
              </Form>
            </Block>
          </Card>
        </Block>

        <Modal
          isOpen={addLinkModal}
          toggle={() => setAddLinkModal(false)}
          backdrop="static"
          keyboard={false}
          className="modal-dialog-centered"
          size="xs"
        >
          <ModalBody>
            <a
              href="#cancel"
              onClick={(ev) => {
                ev.preventDefault();
                setAddLinkModal(false);
              }}
              className="close"
            >
              <Icon name="cross-sm" />
            </a>
            <div className="p-2">
              <h5 className="title">Tambah Link</h5>
              <div className="mt-4">
                <Form key="link" className="row gy-4" onSubmit={handleSubmitLink(addLink)}>
                  <Col md="12" xs="12" lg="12">
                    <FormGroup>
                      <label>Nama Link</label>
                      <input
                        className="form-control"
                        type="text"
                        name="linkName"
                        placeholder="Nama Link..."
                        ref={registerLink({ required: "This field is required" })}
                        onInput={(e) => {
                          const urlEncode = encodeURIComponent(e.target.value);
                          setValueLink(urlEncode);
                          checkLink(urlEncode);
                        }}
                        onPaste={(e) => e.preventDefault()}
                        onKeyDown={(e) => {
                          if (e.key === " ") {
                            e.preventDefault();
                          }
                        }}
                      />
                      {errorLink.linkName && <span className="invalid">{errorLink.linkName.message}</span>}
                    </FormGroup>
                  </Col>
                  <Col md="12" xs="12" lg="12">
                    <FormGroup>
                      <label>Catatan</label>
                      <input
                        className="form-control"
                        type="text"
                        name="description"
                        placeholder="Tambah Catatan..."
                        ref={registerLink({ required: "This field is required" })}
                      />
                      {errorLink.description && <span className="invalid">{errorLink.description.message}</span>}
                    </FormGroup>
                  </Col>
                  <Col md="12" xs="12" lg="12">
                    <Button type="submit" color="primary">
                      Simpan
                    </Button>
                  </Col>
                </Form>
              </div>
            </div>
          </ModalBody>
        </Modal>
        <Modal
          onClosed={() => {}}
          isOpen={successModal}
          toggle={() => {
            setSuccessModal(false);
          }}
        >
          <ModalBody>
            <div className="d-flex flex-column align-items-center">
              <h6 className="text-center text-primary">Yay! your link has been updated successfully</h6>
              {/* <div className="d-flex justify-content-center mt-2">
                <div
                  className={classNames({ "selector-active": toggleLink }, "text-center link-modal-button-selector")}
                  onClick={() => setToggleLink(true)}
                >
                  <Icon name="link " style={{ fontSize: "70px" }} />
                  <p className="font-weight-bold" style={{ fontSize: "20px" }}>
                    LINK
                  </p>
                </div>
                <div
                  className={classNames({ "selector-active": !toggleLink }, "text-center link-modal-button-selector")}
                  onClick={() => setToggleLink(false)}
                >
                  <Icon name="qr " style={{ fontSize: "70px" }} />
                  <p className="font-weight-bold" style={{ fontSize: "20px" }}>
                    QR CODE
                  </p>
                </div>
              </div>
              <div className="my-5">
                {//console.log("formdata", formData)}
                {!toggleLink ? (
                  <>
                    <QRCode value={formData?.shortlink?.replace(/\s/g, "")} size={225} fgColor="#545454" />{" "}
                  </>
                ) : (
                  <div className="d-flex">
                    <input
                      type="text"
                      value={formData?.shortlink?.replace(/\s/g, "")}
                      disabled
                      className="rounded-left"
                    />
                    <Tooltip
                      placement="top"
                      isOpen={tooltipOpen}
                      toggle={() => setTooltipOpen(false)}
                      target="copy-tooltip"
                    >
                      Copied!
                    </Tooltip>
                    <CopyToClipboard text={formData.shortlink} onCopy={() => setTooltipOpen(true)}>
                      <div className="copy-link-button rounded-right" id="copy-tooltip">
                        <p>Copy Link</p>
                      </div>
                    </CopyToClipboard>
                  </div>
                )}
              </div> */}
              <div className="my-5">
                <QRCode value={formData.shortlink} size={225} fgColor="#545454" />{" "}
                <div className="d-flex mt-5">
                  <input
                    type="text"
                    value={formData?.shortlink?.replace(/\s/g, "")}
                    disabled
                    className="rounded-left"
                  />
                  <Tooltip
                    placement="top"
                    isOpen={tooltipOpen}
                    toggle={() => setTooltipOpen(false)}
                    target="copy-tooltip"
                  >
                    Copied!
                  </Tooltip>
                  <CopyToClipboard text={formData.shortlink} onCopy={() => setTooltipOpen(true)}>
                    <div className="copy-link-button rounded-right" id="copy-tooltip">
                      <p>Copy Link</p>
                    </div>
                  </CopyToClipboard>
                </div>
              </div>
              <a href="/campaign" className="text-center">
                Kembali<span>{">"}</span>
              </a>
            </div>
          </ModalBody>
        </Modal>
      </Content>
    </React.Fragment>
  );
};

export default DetailCampaign;
